<app-side-bar-info
  *ngIf="this.nodeSelected"
  [node]="nodeSelected"
  [layoutMode]="layoutMode"
  (layoutModeChange)="changeLayoutMode($event)"
  (manageNewNodesUpdate)="manageNewNodesUpdate($event)"
>
</app-side-bar-info>

<div style="height: 160px"></div>
<div
  class="col-lg-8 control-section top-4 transition-all"
  style="width: 100%"
  [class]="this.nodeSelected ? '-ml-60' : ''"
>
  <div class="control-section">
    <ejs-diagram
      *ngIf="refresh"
      #diagram
      class="border-none"
      id="diagram"
      width="100%"
      [layout]="layout"
      [dataSourceSettings]="data"
      [snapSettings]="snapSettings"
      [getConnectorDefaults]="getConnectorDefaults"
      [getNodeDefaults]="getNodeDefaults"
      (selectionChange)="selectionChange($event)"
      (sourcePointChange)="connectionChange($event)"
      (targetPointChange)="connectionChange($event)"
    >
    </ejs-diagram>
  </div>
</div>
